<nb-layout>
  <nb-layout-column>
    <div MyOverlayContainer>
      <mat-sidenav-container autosize="true">
        <mat-sidenav #sidenav mode="side" opened="true">
          <app-sidenav></app-sidenav>
        </mat-sidenav>       
        <mat-sidenav-content>
          <app-toolbar (selectedLang)="selectedLang($event)"></app-toolbar>
          <router-outlet></router-outlet>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </div>
  </nb-layout-column>
</nb-layout>